
export const ADMIN_PARAMETRES_INITIATE_MODIFIER_PARAMETRES = 'ADMIN_PARAMETRES_INITIATE_MODIFIER_PARAMETRES';
export const ADMIN_PARAMETRES_MODIFIER_PARAMETRES_START = 'ADMIN_PARAMETRES_MODIFIER_PARAMETRES_START';
export const ADMIN_PARAMETRES_MODIFIER_PARAMETRES_SUCCESS = 'ADMIN_PARAMETRES_MODIFIER_PARAMETRES_SUCCESS';
export const ADMIN_PARAMETRES_MODIFIER_PARAMETRES_FAIL = 'ADMIN_PARAMETRES_MODIFIER_PARAMETRES_FAIL';
export const ADMIN_PARAMETRES_MODIFIER_PARAMETRES_RESET = 'ADMIN_PARAMETRES_MODIFIER_PARAMETRES_RESET';
